module.exports = __webpack_public_path__ + "img/Happy New Year - Copy.cf117e2.jpg";